// extracted by css-extract-rspack-plugin
export default {"backdrop":"header-fragment__Backdrop_backdrop__yhvs1","hide":"header-fragment__Backdrop_hide__7KURk","show":"header-fragment__Backdrop_show__BcRmq"};